"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselSkipLink = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Text = require("../Text/Text");
var _CarouselSkipLink = require("./CarouselSkipLink.styles");
var _excluded = ["children"];
/**
 * A link that's only shown to keyboard users. Allows them to skip all of
 * a `Carousel's` content.
 *
 * @extends Anchor
 * @since 8.71.0
 */
var CarouselSkipLink = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_CarouselSkipLink.StyledCarouselSkipLink, (0, _extends2.default)({
    href: "#",
    ref: forwardedRef
  }, rest), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    fontColor: "link"
  }, children));
});
exports.CarouselSkipLink = CarouselSkipLink;
CarouselSkipLink.displayName = 'CarouselSkipLink';